module.exports = __webpack_public_path__ + "static/media/garden.c582181a.jpg";